/**
 * BM fix: Recently Viewed section images
 *
 * WHY THIS FILE EXISTS (don't remove without checking with dev team):
 *   The base Impulse theme's assets/theme.js has two bugs affecting the
 *   "Recently viewed" section (sections/recently-viewed.liquid):
 *
 *   1. `addImageProperties()` (inside theme.buildProductImage) sets
 *      imageEl.srcset = product.featured_media, but `featured_media` is
 *      never set anywhere - only `image_responsive_url`/`image_responsive_urls`
 *      are. That makes srcset literally the string "undefined", which
 *      breaks the <img> entirely even though `src` itself is fine.
 *
 *   2. theme.RecentlyViewed.prototype.setupOutput always builds the image
 *      from product.featured_image (the 1st/default photo). This store
 *      intentionally shows the 3rd photo everywhere else (see the
 *      `product.images[2]` override in snippets/product-grid-item.liquid,
 *      which this file does NOT touch), so Recently Viewed was showing a
 *      different photo than the rest of the site even when it did load.
 *
 *   Separately (not a bug, just an inefficiency): theme.Product.prototype.
 *   addIdToRecentlyViewed writes every product a visitor views into
 *   localStorage with no cap, and RecentlyViewed.prototype.init fetches
 *   product data for EVERY handle stored there (not just the ones about to
 *   be shown) before deciding what to display. A long browsing history
 *   means dozens of wasted parallel network requests on every product page
 *   load. Fix 3 below caps that history so it can't grow unbounded.
 *
 * WHAT THIS FILE DOES:
 *   Rather than hand-editing the large, auto-formatted assets/theme.js
 *   bundle (risky to diff/merge on theme updates), this file overrides the
 *   affected functions after theme.js has defined them. It's loaded right
 *   after theme.js in layout/theme.liquid via a second deferred <script>
 *   tag, so `theme.buildProductImage`, `theme.RecentlyViewed`, and
 *   `theme.Product` already exist by the time this file runs (deferred
 *   scripts execute in document order).
 *
 *   Only the functions below are touched. Everything else in theme.js -
 *   including predictive search, the collection grid, add-to-cart, and any
 *   other consumer of theme.buildProductImage or theme.Product - is
 *   untouched.
 */
(function () {
  "use strict";

  if (!window.theme || typeof theme.buildProductImage !== "function") {
    console.warn("[bm-recently-viewed-fix] theme.buildProductImage not found - skipping patch");
    return;
  }

  // Fix 1: srcset must come from image_responsive_urls (plural, an array of
  // "<url>?width=N Nw," strings built by theme.Images.buildImagePath), not
  // the nonexistent product.featured_media.
  theme.buildProductImage = function (product, imageSizes) {
    var size = theme.settings.productImageSize;
    var output = "";

    function addImageProperties(imageEl, imageSizes2) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = (product.image_responsive_urls || []).join(" ");
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes2;
    }

    if (size === "natural") {
      var clonedMarkup = document.getElementById("naturalImageMarkup").content.cloneNode(true);
      var imageEl = clonedMarkup.querySelector("img");
      var imageWrapperEl = clonedMarkup.querySelector(".image-wrap");
      imageWrapperEl.style.paddingBottom = product.image_aspect_ratio + "%";
      addImageProperties(imageEl, imageSizes);
      var imageDiv = document.createElement("div");
      imageDiv.appendChild(clonedMarkup);
      output = imageDiv.innerHTML;
    } else {
      var clonedMarkup2 = document.getElementById("fixedRatioImageMarkup").content.cloneNode(true);
      var imageEl2 = clonedMarkup2.querySelector("img");
      clonedMarkup2.querySelector(".grid__image-ratio").classList.add("grid__image-ratio--" + size);
      if (!theme.settings.productImageCover) imageEl2.classList.add("grid__image-contain");
      addImageProperties(imageEl2, imageSizes);
      var imageDiv2 = document.createElement("div");
      imageDiv2.appendChild(clonedMarkup2);
      output = imageDiv2.innerHTML;
    }

    return output;
  };

  if (!window.theme.RecentlyViewed || !theme.RecentlyViewed.prototype || typeof theme.RecentlyViewed.prototype.setupOutput !== "function") {
    console.warn("[bm-recently-viewed-fix] theme.RecentlyViewed.prototype.setupOutput not found - skipping patch");
    return;
  }

  // Fix 2: use the 3rd photo (product.images[2]) to match the rest of the
  // site, falling back to the default featured_image if a product has 2 or
  // fewer photos.
  theme.RecentlyViewed.prototype.setupOutput = function (products) {
    var allProducts = [];
    var limit = this.container.getAttribute("data-recent-count");
    var self = this;

    Object.keys(products).forEach(function (key) {
      if (!products[key]) return;
      var product = JSON.parse(products[key]);
      if (product.handle === self.handle || typeof product.handle > "u") return;

      var widths = [180, 360, 540, 720, 900];
      var recentEntry = theme.recentlyViewed.recent[product.handle];

      product.url = recentEntry ? recentEntry.url : product.url;

      var previewImage = (product.images && product.images.length > 2) ? product.images[2] : product.featured_image;
      product.image_responsive_url = theme.Images.buildImagePath(previewImage);
      product.image_responsive_urls = theme.Images.buildImagePath(previewImage, widths);
      product.image_aspect_ratio = recentEntry ? recentEntry.aspectRatio : product.image_aspect_ratio;

      var firstVariant = product.variants[0];
      if (firstVariant && firstVariant.unit_price) {
        var baseUnit = "";
        if (firstVariant.unit_price_measurement) {
          if (firstVariant.unit_price_measurement.reference_value != 1) {
            baseUnit += firstVariant.unit_price_measurement.reference_value + " ";
          }
          baseUnit += firstVariant.unit_price_measurement.reference_unit;
        }
        product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
        if (baseUnit != "") product.unit_price += "/" + baseUnit;
      }

      allProducts.unshift(product);
    });

    if (allProducts.length === 0) {
      this.container.classList.add("hide");
      return;
    }

    var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf, this.imageSizes);
    this.outputContainer.innerHTML = productMarkup;
    if (window.AOS) AOS.refreshHard();
  };

  // Fix 3: cap the stored Recently Viewed history so it can't grow forever.
  //
  // theme.Product.prototype.addIdToRecentlyViewed (the function that writes
  // the current product into theme.recentlyViewed.recent) runs synchronously
  // as part of theme.js's own top-level initialization - which happens
  // *before* this second <script> tag gets a chance to run at all. That
  // means overriding that function here would always be one page load too
  // late to catch the current page's own write.
  //
  // Instead of intercepting the write, this simply trims
  // theme.recentlyViewed.recent down to the most recent 20 entries right
  // here, once, every time this script runs (i.e. once per page load). By
  // this point theme.js has already finished writing the current product to
  // it, so this reliably catches the result of that write no matter when or
  // how it happened. Nothing about the write itself, or about fetching/
  // displaying Recently Viewed (Fix 1 and Fix 2 above), is touched.
  if (window.theme.recentlyViewed && theme.recentlyViewed.recent && typeof theme.recentlyViewed.recent === "object") {
    var RECENTLY_VIEWED_MAX = 20;
    var keys = Object.keys(theme.recentlyViewed.recent);
    if (keys.length > RECENTLY_VIEWED_MAX) {
      // Keys are in insertion order (oldest first); drop the oldest excess.
      var toRemove = keys.slice(0, keys.length - RECENTLY_VIEWED_MAX);
      toRemove.forEach(function (handle) {
        delete theme.recentlyViewed.recent[handle];
      });
      if (theme.config.hasLocalStorage) {
        window.localStorage.setItem("theme-recent", JSON.stringify(theme.recentlyViewed.recent));
      }
    }
  }
})();
